<template>
    <!-- 订单统计 -->
    <div>
        <!-- 头部-->
        <div class="city-child-head">
            <!-- 标题 -->
            <div class="city-child-head-left float-l">
                <div class="city-child-head-icon"></div>
                <span>订单统计</span>
            </div>
        </div>
        <!-- 内容 -->
        <div class="city-content city-content-chunk-box">
            <!-- 内容 -->
            <div class="city-box">
                <div class="city-box-1 d-flex">
                    <div class="city-box-3">
                        <div>已支付金额(元)</div>
                        <img class="city-box-3-img" src="../../assets/u118.png">
                    </div>
                    <div class="city-box-2">
                        <div class="t-title">累计</div>
                        <div class="t-text">{{ countPay }}</div>
                        <div class="t-title">本月</div>
                        <div class="t-text">{{ monthPay }}</div>
                    </div>
                </div>
                <div class="city-box-1 d-flex">
                    <div class="city-box-3">
                        <div>已支付订单(笔)</div>
                        <img class="city-box-3-img" src="../../assets/u120.png">
                    </div>
                    <div class="city-box-2">
                        <div class="t-title">累计</div>
                        <div class="t-text">{{ countPayRecordNum }}</div>
                        <div class="t-title">本月</div>
                        <div class="t-text">{{ monthPayRecordNum }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getTransportOrderStatistics } from '../../api/holdMy.js';
export default {

    data() {
        return {
            refreshImgIng: null,   // 刷新定时器
            countPay: 0, // 累计支付金额
            countPayRecordNum: 0, // 累计支付笔数
            monthPay: 0, // 本月支付金额
            monthPayRecordNum: 0, // 本月支付笔数
            getData: {
                cityName: this.$route.query.cityName,
                city: this.$route.query.cityName,
            },
        }
    },
    components: {},
    created() {

    },
    mounted() {
        this.refreshScale();
    },

    beforeDestroy() {
        clearInterval(this.refreshImgIng);
    },
    methods: {
        // 刷新数据
        refreshScale() {
            this.transportOrderStatistics();
            this.refreshImgIng = setInterval(() => {
                this.transportOrderStatistics();
            }, 1000 * 60 * 30)
        },

        //  获取订单统计
        transportOrderStatistics() {
            getTransportOrderStatistics({ ...this.getData }).then(res => {
                if (res.result == 0) {
                    this.countPay = res.userdata.countPay;
                    this.countPayRecordNum = res.userdata.countPayRecordNum;
                    this.monthPay = res.userdata.monthPay;
                    this.monthPayRecordNum = res.userdata.monthPayRecordNum;
                }
            }).catch(error => {
                console.log(error);
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.city-content {
    height: 258px;

    .city-box {
        margin: 14px;

        .city-box-1 {
            font-family: '微软雅黑', sans-serif;
            font-weight: 400;
            font-size: 14px;
            color: #739DC2;
        }

        .city-box-2 {
            font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
            font-weight: 700;
            font-style: normal;
            color: #66BBF9;
            margin: 22px 0 15px 0;
        }

        .city-count {
            font-size: 36px;
            margin-right: 10px;
        }

        .city-box-3 {
            margin-right: 10px;
            font-size: 12px;
            font-weight: 350;
            color: #FFFFFF;
            line-height: 17px;

            &-img {
                margin-top: 27px;
                width: 85px;
                height: 62px;
            }
        }
    }
}
</style>

<style >
.city-child-head {
    font-family: 微软雅黑, sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 20px;
    color: rgb(255, 255, 255);
    text-align: left;

    height: 20px;

}

.city-child-head-left {
    display: flex;
}

.city-child-head-icon {
    width: 7px;
    height: 22px;
    padding: 0px 0px 0px 15px;
    border-width: 0px 0px 0px 5px;
    border-style: solid;
    border-color: rgb(49, 167, 255);
}

.city-content-chunk-box {
    margin-top: 12px;
    background-color: rgba(0, 145, 255, 0.1);
    border: 1px solid rgba(0, 159, 233, 0.479);
}
</style>